import cs from 'classnames';
import { useField, useFormikContext } from 'formik';
import React from 'react';
import {
  Col,
  Row,
} from 'react-bootstrap';
import { BadgeWithTooltip } from '../../../ui/AvatarTool/BadgeWithTooltip/BadgeWithTooltip';
import { IAchievementModal } from '../AchievementsModalTypes';
import { AchievementField } from './AchievementField';
import css from './AchievementRow.module.scss';
import { AchievementWhenField } from './AchievementWhenField/AchievementWhenField';

export interface AchievementRowGamePassProps {
  index: number;
}

export const gamePassAchievementTooltipContent = () => (
  <>
    <p><strong>GamePass Achievement</strong></p>
    <p>This is a special system achievement that integrates with the GamePass platform.</p>
    <ul>
      <li>Automatically unlocked for GamePass subscribers</li>
      <li>Cannot be edited or deleted by story creators</li>
      <li>Can be used in stories like regular achievements</li>
      <li>Enables free access to premium choices for GamePass users</li>
      <li>Helps creators reward users who access premium content</li>
    </ul>
    <p><strong>Usage in Stories:</strong></p>
    <ol>
      <li>Open the story editor and create an achieve step</li>
      <li>Select &quot;GamePass&quot; from the available achievements list</li>
      <li>GamePass users who reach this step will automatically unlock the achievement</li>
      <li>These users also get free access to any premium choices in your story</li>
    </ol>
  </>
);

export function AchievementRowGamePass(props: AchievementRowGamePassProps) {
  const { index } = props;

  const [isManual] = useField(`[${index}].isManual`);
  const { values } = useFormikContext<IAchievementModal[]>();
  const achievement = values[index];

  if (!achievement) return null;

  return (
    <div className={cs(css.row, 'flex-fill')}>
      <Row id={`achievement-row-1-gamepass-${index}`}>
        <Col lg={2}>
          <AchievementField
            id={`[${index}].name`}
            label="Achievement Name"
            placeholder="Achievement Name"
            disabled
          />
          <div className="position-absolute" style={{ top: '0', right: '0' }}>
            <BadgeWithTooltip
              id={`delete-button_${index}`}
              title="GamePass Achievement"
              content={gamePassAchievementTooltipContent()}
            />
          </div>
        </Col>
        <Col lg={2} style={{ maxWidth: '10vw' }}>
          <AchievementWhenField
            rowIndex={index}
            disabled
          />
        </Col>
        {isManual.value && (
          <Col lg={2}>
            -
          </Col>
        )}
        <Col>
          {/* Spacer column */}
        </Col>
        <Col sm="auto" className="my-auto ms-auto">
          {/* GamePass achievements cannot be deleted */}
        </Col>
      </Row>

      <Row id={`achievement-row-2-gamepass-${index}`}>
        <Col lg={2}>
          {/* Reward content */}
        </Col>
        <Col lg={2}>
          {/* Display Name */}
        </Col>
        <Col lg={2}>
          {/* Timeline Label */}
        </Col>
        <Col>
          {/* Description */}
        </Col>
      </Row>
    </div>
  );
}
